import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolder12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFolder12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 3h3.023l.61 1H2zM1 4V3a1 1 0 0 1 1-1h3.023a1 1 0 0 1 .853.479L6.806 4H9.5A1.5 1.5 0 0 1 11 5.5v4A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5zm6.417 1H2v4.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolder12);
